export const HEIGHT_CLASSES = {
	BorderStylePicker: "border-style-picker",
	CheckBox: "checkbox",
	ColorPicker: "color-picker",
	FileInput: "file-input",
	FontPicker: "font-picker",
	GradientInput: "gradient-input",
	NumberInput: "number-input",
	ShadowInput: "shadow-input",
};

export const getRowHeight = componentType => HEIGHT_CLASSES[componentType];
